// 3rd party imports
import * as React from 'react';

// Toolkit
import { UitkDialogContent } from 'uitk-react-dialog';
import { UitkHeading, UitkParagraph } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';

// Bernie
import { LocalizedText } from '@shared-ui/localization-context';

export interface PzFormInfoEligibilityProps {
  programName: string;
}

export const PzFormInfoEligibility: React.FunctionComponent<PzFormInfoEligibilityProps> = ({ programName }) => {
  return (
    <UitkDialogContent>
      <UitkHeading tag="h3" size={5}>
        <LocalizedText message="pz.signup.info.eligibility.title" />
      </UitkHeading>
      <UitkSpacing margin={{ blockstart: 'six' }}>
        <div>
          <UitkParagraph size={1}>
            <LocalizedText message="pz.signup.info.eligibility.paragraph" data={[programName]} />
          </UitkParagraph>
        </div>
      </UitkSpacing>
    </UitkDialogContent>
  );
};
